import {unstable_batchedUpdates} from 'react-dom'

export function createBatch(requestBatch) {
  let callbacks = []
  let isQueued = false

  function flush() {
    const willCall = callbacks
    callbacks = []
    isQueued = false
    for (const cb of willCall) {
      cb()
    }
  }

  function batchedFlush() {
    unstable_batchedUpdates(flush)
  }

  function unbatch(callback) {
    const index = callbacks.indexOf(callback)
    if (index >= 0) callbacks.splice(index, 1)
  }

  return function batch(callback) {
    callbacks.push(callback)
    if (!isQueued) {
      isQueued = true
      requestBatch(batchedFlush)
    }
    return unbatch.bind(null, callback)
  }
}

const defer = (f) => setTimeout(f, 0)
export const batchDefer = createBatch(defer)
export const batchAnimationFrame =
  typeof requestAnimationFrame === 'function'
    ? // eslint-disable-next-line no-undef
      createBatch(requestAnimationFrame)
    : batchDefer
export const batchIdle =
  typeof requestIdleCallback === 'function'
    ? // eslint-disable-next-line no-undef
      createBatch(requestIdleCallback)
    : batchAnimationFrame
